import * as React from "react";
import {
    BetStrategyType,
    PokerVariant,
    SitAndGoConfig,
    TimeZone,
    TournamentConstraints
} from "../../../../../generated/protocol";
import {
    TOURNAMENT_CONSTRAINTS_SERVICE_NAME,
    TournamentConstraintsService
} from "../../../../service/poker/tournament/TournamentConstraintsService";
import {AppCtx} from "../../../../ioc/ApplicationContext";
import {LoadingViewState, RouterView} from "../../RouterView";
import {FormListener} from "../../../form/Form";
import {SitAndGoService} from "../../../../service/poker/tournament/SitAndGoService";
import {Symbols} from "../../../../ioc/Symbols";
import {SitAndGoForm} from "../../../poker/tournament/SitAndGoForm";


interface State extends LoadingViewState {
    tournament?: SitAndGoConfig;
    validationMap?: any;
    errorMessage?: string;
    success?: boolean;
    inProgress?: boolean;
    constraints?: TournamentConstraints;
    timeZones?: TimeZone[];
}

const createInitialState = () => {
    return {
        validationMap: {},
        tournament: {
            configuration: {
                guaranteedPrizePool: 0,
                variant: "TEXAS_HOLDEM" as PokerVariant,
                betStrategy: "NO_LIMIT" as BetStrategyType,
                lateRegistrationLevel: -1,
                seatsPerTable: 9,
                rebuyConfiguration: {
                    numberOfRebuysAllowed: 0
                }
            }
        }
    }
};

interface Props {
    params: { id: string, copyTemplate?: string }
}

export class SitAndGoView extends RouterView<Props, State> implements FormListener<SitAndGoConfig> {

    tournamentService: SitAndGoService;
    constraintsService: TournamentConstraintsService;

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.state, createInitialState());
        this.tournamentService = AppCtx.resolve<SitAndGoService>(Symbols.SitAndGoService);
        this.constraintsService = AppCtx.resolve<TournamentConstraintsService>(TOURNAMENT_CONSTRAINTS_SERVICE_NAME);
    }

    componentDidUpdate(prevProps: Props, prevState) {
        if (prevProps.params.id != this.props.params.id) {
            this.refreshContent();
            return;
        }
        super.componentDidUpdate(prevProps, prevState);
    }

    onTournamentSaveConfirmed() {
        this.navigate("/sit-and-go/" + this.state.tournament.id);
    }


    loadContent(): Promise<any> {
        if (this.props.params.id == "new") {

            let promises = [];
            promises.push(this.constraintsService.getConstraintsByUser());
            if (this.props.params.copyTemplate) {
                promises.push(this.tournamentService.getEntity(this.props.params.copyTemplate));
            }
            return Promise.all<any>(promises).then(results => {
                var initialState = createInitialState();
                let tournament: SitAndGoConfig = initialState.tournament;
                if (this.props.params.copyTemplate) {
                    tournament = results[1];
                    tournament.id = null;
                    tournament.configuration.id = null;
                    if (tournament.configuration.rebuyConfiguration) {
                        tournament.configuration.rebuyConfiguration.id = null;
                    }
                } else {
                    let configuration = Object.assign({}, tournament.configuration);
                    tournament = Object.assign({}, tournament, {configuration: configuration});

                }
                this.setState({
                    constraints: results[0],
                    tournament: tournament,
                    validationMap: {}
                });
            });
        } else {
            return Promise.all<any>([
                this.tournamentService.getEntity(this.props.params.id),
                this.constraintsService.getConstraintsByUser()
            ]).then(results => {
                this.setState({tournament: results[0], constraints: results[1]});
            });
        }

    }

    onSubmit(): Promise<any> {
        return this.tournamentService.save(this.state.tournament).then((t: SitAndGoConfig) => {
            this.setState({tournament: t});
        }).catch(err => {
            console.log("ERROR = ", err);
            throw err.message;
        });
    }

    onSubmitError() {
        console.log("State on error = ", this.state.tournament);
    }

    formDidUpdate(formModel: SitAndGoConfig, validationMap: any) {
        formModel.configuration.maxPlayers = formModel.configuration.minPlayers;
        this.setState({tournament: formModel, validationMap: validationMap});
    }

    getTitle(): string {
        return "Sit & Go";
    }

    restore() {
        return this.tournamentService.restore(this.state.tournament.id).then(tournament => this.setState({tournament: tournament}));
    }

    archive() {
        return this.tournamentService.archive(this.state.tournament.id).then(tournament => this.setState({tournament: tournament}));
    }


    renderContent() {


        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>{this.getTitle()}</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated">
                    <SitAndGoForm
                        tournament={this.state.tournament}
                        constraints={this.state.constraints}
                        validationMap={this.state.validationMap}
                        newTournament={this.props.params.id == "new"}
                        archive={this.archive.bind(this)}
                        restore={this.restore.bind(this)}
                        formListener={this}
                        onSuccessClose={this.onTournamentSaveConfirmed.bind(this)}
                    />
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/view/poker/tournament/SitAndGoView.tsx